import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export default function BuildServicesCataloguePage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem',
    }}>
      {/* Placeholder illustration */}
      <div style={{
        width: 120,
        height: 120,
        borderRadius: '50%',
        background: '#f0f4ff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '2rem',
        fontSize: '3rem',
      }}>
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="12" width="48" height="40" rx="4" stroke="#1e293b" strokeWidth="3" fill="none" />
          <line x1="8" y1="24" x2="56" y2="24" stroke="#1e293b" strokeWidth="3" />
          <line x1="28" y1="24" x2="28" y2="52" stroke="#1e293b" strokeWidth="2" />
          <circle cx="18" cy="18" r="2" fill="#e5c526" />
          <circle cx="24" cy="18" r="2" fill="#e5c526" />
          <circle cx="30" cy="18" r="2" fill="#e5c526" />
          <line x1="16" y1="32" x2="24" y2="32" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
          <line x1="16" y1="38" x2="24" y2="38" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
          <line x1="16" y1="44" x2="24" y2="44" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
          <rect x="34" y="30" width="16" height="16" rx="2" stroke="#e5c526" strokeWidth="2" fill="none" />
          <line x1="42" y1="34" x2="42" y2="42" stroke="#e5c526" strokeWidth="2" strokeLinecap="round" />
          <line x1="38" y1="38" x2="46" y2="38" stroke="#e5c526" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>

      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#1e293b',
        marginBottom: '0.75rem',
      }}>
        {t('buildServices.heading') || 'Build your Services Catalogue now'}
      </h2>

      <p style={{
        color: '#6b7280',
        fontSize: '1rem',
        maxWidth: '400px',
        marginBottom: '2rem',
        lineHeight: 1.6,
      }}>
        {t('buildServices.subtext') || 'Add your services so you start getting orders. Excited?'}
      </p>

      <button
        onClick={() => navigate('/services')}
        style={{
          background: '#4f46e5',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '0.875rem 2.5rem',
          fontSize: '1rem',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = '#4338ca')}
        onMouseLeave={(e) => (e.currentTarget.style.background = '#4f46e5')}
      >
        {t('buildServices.addServices') || 'Add Services'}
      </button>
    </div>
  );
}
